import React from 'react';
import '../styles/Dashboard.css';

/**
 * Dashboard component for displaying PowerBI iframe (responsive)
 */
const Dashboard = () => {
  return (
    <div className="powerbi-container">
      <iframe
        title="Cyberproof Financial Dashboard- 2025 Latest"
        src="https://app.powerbi.com/reportEmbed?reportId=56eb01ea-d0e8-457b-b30d-b27c4f2f88b2&autoAuth=true&ctid=f3030f0a-998c-4a82-852c-1d0777740cf5"
        frameBorder="0"
        allowFullScreen={true}
        loading="lazy"
      />
    </div>
  );
};

export default Dashboard;
